// Product ID to single Variant ID mapping
var tangent_selected_product_map;
var tangent_client_domain_currency;
var default_addToCartText = "ADD TO CART";
var default_addedToCartText = "ADDED TO CART!";
var default_add_all_to_cart_text = "ADD REGIMEN TO CART"
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";

const email_popup_window = document.getElementById("email-popup-backcover");
const stickyTotalAmount = document.getElementById("sticky_total_amount");
const stickyTotalDiscountedAmount = document.getElementById("sticky_discounted_total_amount");
const sticky_add_all_to_cart = document.getElementById("tangent-sticky-add-all-to-cart-link");
const sticky_save_results = document.getElementById("tangent-sticky-save-results-button");
const tangent_form_id = document.getElementById("tangent-form-id").value

let email_present = false;
let tangent_response_id = null;
let data_rendered =false;

let tangent_product_sections;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
let tabs_title_mapping={
  section_basics:"Starter",
  section_essentials:"Essentials",
  section_works:"Complete"
}

// Add default image url here
let tangent_default_selfie_image_url="https://cdn.shopify.com/s/files/1/0016/5144/1717/files/Selfie-Placeholder-Frame.jpg";
let default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
let tangent_client_domain_url = window.location.origin;
let tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tabWrapper = document.querySelector("#tab-wrapper");


window.onload = function() {
    tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const market = document.getElementById("tangent-shop-country").value;
    var checkout_url = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${tangent_response_id}&self_serve=true&multiple_variants=true&market=${market}`;
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;
    /*email_present = userEmailPresent(response);
    if(email_present){
      hideElement(sticky_save_results);
    }
    else{
      showElement(sticky_save_results);
    }*/

    // Setting selfie / default image
    setTangentSelfieSection(response);

    const psoriasisPresent = isPsoriasisPresent(response.tags);
  
    tangent_product_sections = response.product_sections;
    let tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections, psoriasisPresent);
    }    
  
    let selectedSection = setTabOpen(response.tags);
    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      tangent_client_domain_currency = tangent_recommended_products[0].variants.edges[0].node.contextualPricing.price.currencyCode;
      setProductsToView(response, tangent_recommended_products, tangent_product_sections);
      enableButtonListener();
      loadElementsOnResponseData();    
      
      setStickyAddToCartLink(selectedSection);

      // setReverseOrderForSectionAddToCart();
      showElement(document.getElementById("tangent-sticky-action-buttons"));
      showElement(document.getElementById("tangent-sticky-add-all-to-cart-button"));
      
      data_rendered = true;
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
    addConcernFromTags(response);
    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }

}

function isPsoriasisPresent(tags){
  return tags.includes("skin_concern_psoriasis");
}

function setReverseOrderForSectionAddToCart(){
  for (var sectionName in sections_add_to_cart_map) {
    let list = sections_add_to_cart_map[sectionName].list;
    // sections_add_to_cart_map[sectionName].cart_link = createCustomCartOrder(list);
    // const addAllButtonLink = document.getElementById(`${sectionName}_add_all_cart_link`);
    // addAllButtonLink.href = sections_add_to_cart_map[sectionName].cart_link;    
  }
}

function setProductsToView(response, products, sections) {
  tangent_selected_product_map = {};
  let selected_variants = response.selected_variants;
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    
    // Create a variable to accumulate the HTML
    let section_html = "";

    const badgeContainer = getBadgeContainer(section);
    
    for (let id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        if (String(products[p].id) === id) {
          let product = products[p];
          // Ensure product has variants
          if (product.variants.edges.length > 0) {
            let variant = product.variants.edges[0].node;
            if(selected_variants[products[p].id].length>0){
              variant = getMatchingVariantFromProduct(selected_variants[products[p].id], product.variants.edges);
            }
            // Update the selected product map
            tangent_selected_product_map[product.id] = variant.id;

            // Generate the product HTML
            let product_html = getProductHTML(product, p, variant, section, sections, badgeContainer);

            // Accumulate the HTML
            section_html += product_html;
          }
        }
      }
    }
    updateProductGrids(section, section_html);
  });
}

function getMatchingVariantFromProduct(variantId, variantsList){
  const variantsMap = new Map(
    variantsList.map(variant => {
      const id = variant.node.id.split('/').pop(); // Extract ID safely
      return [id, variant.node];
    })
  );
  for (let [key, value] of variantsMap) {
      if(key==variantId){
        return value;
      }
  }
  // Return the matching variant or default to the first one
  return variantsList[0].node;
}

function getProductHTML(product, index, variant, section, sections, badgeContainer) {
  
  // Set default / first variant data
  let product_price = variant.contextualPricing.price.amount;
  let discounted_price = getDiscountedPrice(product_price);
  
  let variant_image_url = variant.image ? variant.image.url : product.images.nodes[0].url;
  let variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');
  let variant_product_url = `${product.onlineStoreUrl}?variant=${variant_id}`;
  let product_metatext="";
  if(product.metafield3){
    product_metatext = product.metafield3.value ? product.metafield3.value : "";
  }
  let add_to_cart_classlist="";
  if(!isProductActive(product, variant)){
    default_addToCartText = out_of_stock_text;
    add_to_cart_classlist = "disable-btn-wrapper";
  }
  else{
    updateSectionAllToCartLink(section, variant, variant_id);
  }
  tangent_selected_product_map[product.id] = variant_id;

  let starRatingHTML = getRatingView(product.metafield1,product.metafield2);
  // Generate Product HTML
  let product_html = `
    <div class="product-card-inner-container">
      ${badgeContainer}
      <div>
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
        </a>
        ${starRatingHTML}
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">
          ${getCurrencyFormattedPrice(tangent_client_domain_currency, product_price)} &nbsp;<span style="color:#E63862;font-weight: 700;">${getCurrencyFormattedPrice(tangent_client_domain_currency, discounted_price)}</span> with code: REGIMEN20          
        </p>
        <div id="${section}_variant_${index}"></div>
      </div>
      <div>
        <p class="tangent-btn-add tangent_add_to_cart_button ${add_to_cart_classlist}" id="${section}_cart_tangent_product_${index}_text">
          <a class="tangent-product-add-btn-wrapper" id="${variant_id}" href="javascript: void(0)">${default_addToCartText}</a>
        </p>
        <p class="tangent-product-meta-content">${product_metatext}</p>
      </div>
        
    </div>
  `;
  
  return product_html;
}

function getBadgeContainer(sectionName) {
  return sectionName === "section_psoriasis"
    ? `<div class="badge-container">
        <img class="badge-image" src="https://cdn.shopify.com/s/files/1/0016/5144/1717/files/Eczema_514a6934-c6e1-4fb2-9a1e-4cc494f37e00.png?v=1748578659" />
        <img class="badge-image" src="https://cdn.shopify.com/s/files/1/0016/5144/1717/files/psoriasis-2.png?v=1748578975" />
      </div>`
    : '';
}
function getDiscountedPrice(price) {
    const discount = 0.20; // 20% discount
    const discountedPrice = price - (price * discount);
    return discountedPrice.toFixed(2);
}

function getRatingView(rating, reviews) {
  const MAX_RATING = 5;
  const BASE_WIDTH = 60;

  let ratingContainer = document.createElement("div");
  ratingContainer.classList.add("tangent-rating-container");

  if (isValidRating(rating)) {
    const starHtml = createStarRating(rating.value, MAX_RATING, BASE_WIDTH);
    ratingContainer.appendChild(starHtml);
  }

  if (isValidReviewCount(reviews)) {
    const reviewHtml = createReviewCount(reviews.value);
    ratingContainer.appendChild(reviewHtml);
  }

  return ratingContainer.outerHTML;
}

function isValidRating(rating) {
  return rating && !isNaN(rating.value);
}

function isValidReviewCount(reviews) {
  return reviews && !isNaN(reviews.value);
}

function createStarRating(ratingValue, maxRating, baseWidth) {
  const starHtml = document.createElement("div");
  starHtml.id = "starRating";
  starHtml.classList.add("Stars");
  starHtml.style.setProperty("--rating", ratingValue);
  
  // Update the aria-label for accessibility
  starHtml.setAttribute("aria-label", `Rating of this product is ${ratingValue} out of 5.`);
  return starHtml;
}

function createStarRating(ratingValue, maxRating = 5, baseWidth = 20) {
  // Create the star rating container
  const starHtml = document.createElement("div");
  starHtml.id = "starRating";
  starHtml.classList.add("Stars", "star-container");

  // Set dynamic styles using CSS variables
  starHtml.style.setProperty("--rating", ratingValue);
  starHtml.style.setProperty("--max-rating", maxRating);
  starHtml.style.setProperty("--star-width", `${baseWidth}px`);

  // Add accessibility attributes
  starHtml.setAttribute("role", "img");
  starHtml.setAttribute(
    "aria-label",
    `Rating of this product is ${ratingValue} out of ${maxRating}.`
  );

  return starHtml;
}

function createReviewCount(reviewCount) {
  // Create the container element
  const reviewHtml = document.createElement("div");
  reviewHtml.classList.add("reviews-count");

  // Add inner HTML with dynamic text for singular/plural cases
  const reviewText = reviewCount === 1 ? "REVIEW" : "REVIEWS";
  reviewHtml.innerHTML = `&nbsp;${reviewCount} ${reviewText}`;

  // Add an aria-label for accessibility
  reviewHtml.setAttribute("aria-label", `This product has ${reviewCount} ${reviewText.toLowerCase()}.`);

  return reviewHtml;
}

function isProductActive(product, variant){
  if (product.status !== "ACTIVE") {
        return false;
  }
  const { inventoryPolicy, inventoryQuantity } = variant;
  
  // Check inventory policy and quantity
  if (inventoryPolicy === "deny" && inventoryQuantity < 1) {
      return false;
  } else {
      return true;
  }
}

function updateProductGrids(section, productHTML) {
  
    // Cache and update the general product section grid
    const productSectionGrid = document.getElementById(section+"_product_grid");
    // Append all the HTML to the section's product grid in one go
    productSectionGrid.insertAdjacentHTML('afterbegin', productHTML);
    if(section=="section_treat_restore"){
      let essentialsGrid = document.getElementById("section_essentials_product_grid");
      let worksGrid = document.getElementById("section_works_product_grid");

      // Ensure both grids exist before updating
      if (essentialsGrid) essentialsGrid.insertAdjacentHTML('afterbegin', productHTML);
      if (worksGrid) worksGrid.insertAdjacentHTML('afterbegin', productHTML);
    }
    
    if(section=="section_additional_products_acne"){
      let additional_product_section_grid = document.getElementById("section_additional_products_product_grid");
      additional_product_section_grid.insertAdjacentHTML('beforeend', productHTML);
    }
}

function setTabOpen(tags) {
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");
  
  // Check if elements exist
  if (!tabWrapper || tabContents.length === 0 || tabLinks.length === 0) return;

  // Show tab wrapper
  tabWrapper.style.display = "block";

  // Determine the default tab index based on tags
  let tabIndex = 0;
  if (tags.includes("depends_on_day")) {
    tabIndex = 1;
  } else if (tags.includes("everything_showers_everyday")) {
    tabIndex = 2;
  }
  
  // Hide all tab content and remove 'active' class from all links
  tabContents.forEach(tab => tab.style.display = "none");
  tabLinks.forEach(link => link.classList.remove("active"));

  // Show the appropriate tab content and activate the corresponding tab link
  tabContents[tabIndex].style.display = "block";
  tabLinks[tabIndex].classList.add("active");
  return tabLinks[tabIndex].name;
}

function setStickyAddToCartLink(sectionName) {
  // Validate if section exists in the map
  const sectionData = sections_add_to_cart_map[sectionName];
  if (sectionData && sectionData.totalPrice && sectionData.cart_link) {
    // Update the sticky Add to Cart text and link
    sticky_add_all_to_cart.innerHTML = `${default_add_all_to_cart_text} ${getCurrencyFormattedPrice(tangent_client_domain_currency, sectionData.totalPrice)}`;
    sticky_add_all_to_cart.href = createCustomCartOrder(sectionData.list);

    // Update the sticky price and discounted price
    //stickyTotalAmount.innerHTML = `${tangent_client_domain_currency}${sectionData.totalPrice}`;
    stickyTotalDiscountedAmount.innerHTML = `${getCurrencyFormattedPrice(tangent_client_domain_currency, getDiscountedPrice(sectionData.totalPrice))}`;
  }
}

function createCustomCartOrder(list){

  list = customProductOrder(list);
  
  let webLink = `${tangent_client_domain_url}/cart/add?id[]=${list[list.length - 1]}`;
  for (let index = list.length - 2; index >= 0; index--) {
    webLink += `&id[]=${list[index]}`;
  }

  return webLink;
}

function customProductOrder(list){
  let pid;
  if(tangent_product_sections.section_treat_restore){
    pid = tangent_product_sections.section_treat_restore[0];
  }
  let index = list.indexOf(tangent_selected_product_map[pid]);
  if (index !== -1) {
    list.splice(index, 1);
    list.push(tangent_selected_product_map[pid]);
  }
  return list;
}

function updateDiscountPriceText(price){
    const original_price_element = document.getElementById("tangent-total-discount-amount");
    original_price_element.innerHTML = `${getCurrencyFormattedPrice(tangent_client_domain_currency, price)}`;
    
    const discounted_price = getDiscountedPrice(price);
    const discounted_price_element = document.getElementById("tangent-total-discount-amount");
    discounted_price_element.innerHTML = `${getCurrencyFormattedPrice(tangent_client_domain_currency, discounted_price)}`;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(section, variant, variant_id) {
    // Retrieve the section map entry
    if(section == "section_treat_restore"){
      updateSectionAddToCartMap("section_essentials", variant, variant_id);    
      updateSectionAddToCartMap("section_works", variant, variant_id);    
    }
    else{
      updateSectionAddToCartMap(section, variant, variant_id);    
    }  
}

function updateSectionAddToCartMap(section , variant, variant_id){
  let section_map = sections_add_to_cart_map[section];
  if (!section_map) {
    section_map = {
        count: 0,
        cart_link: `${tangent_client_domain_url}/cart/add?`,
        list: [],
        totalPrice:0
    };
  }
  // Add the variant if it's not already in the list
  if (!section_map.list.includes(variant_id)) {
      section_map.list.push(variant_id);
      section_map.count++;
      section_map.cart_link += `&id[]=${variant_id}`;
      section_map.totalPrice = section_map.totalPrice + Number(variant.contextualPricing.price.amount);
      
      // Show the "Add All to Cart" button if there's more than 1 product
      if (section_map.count > 1) {
          const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
          const addAllButtonLink = document.getElementById(`${section}_add_all_cart_link`);

          setDiscountedTextPrice(section, section_map);
          if (addAllButton) {
              addAllButton.style.display = "flex";
              addAllButtonLink.href = createCustomCartOrder(section_map.list);
              if(tangent_form_id == "67efb37ca5f62bd5bace3cd5"){
                addAllButtonLink.innerHTML = default_add_all_to_cart_text;
              } else {
                addAllButtonLink.innerHTML = default_add_all_to_cart_text +" "+getCurrencyFormattedPrice(tangent_client_domain_currency, section_map.totalPrice);
              }
          }
      }
      sections_add_to_cart_map[section]= section_map;
  }
}

function setDiscountedTextPrice(sectionName, sectionMap){
  //const totalPriceElement = document.getElementById(sectionName+"_total_amount");
  //totalPriceElement.innerHTML = tangent_client_domain_currency + sectionMap.totalPrice;
  const discountedPriceElement = document.getElementById(sectionName+"_discounted_total_amount");
  discountedPriceElement.innerHTML = getCurrencyFormattedPrice(tangent_client_domain_currency, getDiscountedPrice(sectionMap.totalPrice));
}

function getCurrencyFormattedPrice(currencyCode, price) {
  const symbol = new Intl.NumberFormat("en", {style: 'currency', currency:currencyCode,}).formatToParts("1").find(part=>part.type="currency").value;
  price = (Math.round(price * 100) / 100).toFixed(2)  
  return `${symbol}${price}`;
}

function userEmailPresent(recommendation_data){
  return recommendation_data.email_available;
}

// Add all to cart function for sections
function addAllTocartFunction(section) { 
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function setElementDisplay(element_id, displayType){
  document.querySelector("#"+element_id).style.display=displayType;  
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
     if(btn!=undefined){
        btn.innerHTML = default_addedToCartText;
        btn.classList.add("added-to-cart-style"); 
      }    
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      })); 
      return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function createSectionContainer(section_name) {
  const excludedSections = [
    "section_psoriasis",
    "section_additional_products",
    "section_treat_restore",
    "section_additional_products_acne"
  ];

  const section_container = document.createElement("div");
  section_container.id = section_name + "_container";

  if (!excludedSections.includes(section_name)) {
    section_container.classList.add("tabcontent");
  }

  return section_container;
}


// Add to cart button for sections
function createSectionAddAllToCart(sectionName) {
    const addAllToCartButton = createAddToCartButton(sectionName);
    const addAllCartLink = createAddToCartLink(sectionName, default_add_all_to_cart_text);
    addAllToCartButton.appendChild(addAllCartLink);
    return addAllToCartButton;
}    

function createDiscountPriceText(sectionName){
  const discountText = document.createElement("p");
  discountText.id = `${sectionName}_discounted_text`;
  discountText.classList.add("section_discounted_text", `${sectionName}_discounted_text`);
  discountText.innerHTML = `<s style="color:#999999"><span id="${sectionName}_total_amount" class="tangent-total-amount"></span></s> &nbsp; <span id="${sectionName}_discounted_total_amount" class="tangent-total-discount-amount"></span> with code: REGIMEN20`
  return discountText;
}

function createAddToCartButton(sectionName) {
    const container = document.createElement("p");
    container.id = `${sectionName}_add_all_to_cart`;
    container.classList.add("section_add_all_to_cart", `${sectionName}_add_all_to_cart`);
    return container;
}

function createAddToCartLink(sectionName, linkText) {
    const link = document.createElement("a");
    link.id = `${sectionName}_add_all_cart_link`;
    link.classList.add("section_add_all_cart_link", `${sectionName}_add_all_cart_link`);
    link.href = "#";
    link.innerHTML = linkText;
    // Add click listener
    // link.addEventListener('click', () => addAllToCartFunction(sectionName), false);
    return link;
}

// Container having individual products
function addSectionProductGridContainer(sectionName) {
    const productGridContainer = createProductGridContainer(sectionName);
    return productGridContainer;
}

function createProductGridContainer(sectionName) {
    const container = document.createElement("div");
    container.id = `${sectionName}_product_grid`;
    container.classList.add("section_product_grid", `${sectionName}_product_grid`);
    return container;
}

// Tab buttons 
function createTabButton(sectionName, psoriasisPresent) {
  const excludedSections = [
    "section_treat_restore",
    "section_additional_products",
    "section_additional_products_acne",
    "section_psoriasis"
  ];

  if (!excludedSections.includes(sectionName) && !psoriasisPresent) {
    const tabButton = createButtonElement(sectionName);
    addTabButtonEvent(tabButton);
    tangent_custom_tabs.appendChild(tabButton);
  }
}


function createButtonElement(sectionName) {
  const button = document.createElement("button");
  button.id = `${sectionName}_tab_button`;
  button.innerHTML = getTabTitle(sectionName);
  button.name = sectionName;
  button.classList.add("tablinks");
  return button;
}

function addTabButtonEvent(button) {
  button.addEventListener('click', function () {
    switchTab(this);
    setStickyAddToCartLink(button.name);
  }, false);
}

function getTabTitle(section) {
    return tabs_title_mapping[section] || formatSectionName(section);
}

function formatSectionName(section) {
    return section.replace("section_", "").replace("_", " ").toUpperCase();
}

function createProductSection(productSections, textSections, psoriasisPresent) {
    for (const sectionName in productSections) {
        const sectionContainer = createSectionContainer(sectionName);

        // Create text section before products if exists
        if (textSections !== undefined) {
            createTextSectionBeforeProducts(textSections, sectionContainer, sectionName);
        }

        // Create and append product grid container
        appendProductGridContainer(sectionContainer, sectionName);

        appendDiscountText(sectionContainer,sectionName);
      
        // Create and append the 'add all to cart' button
        appendAddAllToCartButton(sectionContainer, sectionName);

        handleSpecialSections(sectionContainer, sectionName, psoriasisPresent);

        // Add the section to the main container or special containers
        appendSectionToMainContainer(sectionContainer, sectionName);
        
        createTabButton(sectionName, psoriasisPresent);
        
        if(psoriasisPresent){
          tabWrapper.style.display = "block";
        }
    }
}

function appendProductGridContainer(sectionContainer, sectionName) {
    sectionContainer.appendChild(addSectionProductGridContainer(sectionName));
}

function appendDiscountText(sectionContainer, sectionName){
  sectionContainer.appendChild(createDiscountPriceText(sectionName));
}

function appendAddAllToCartButton(sectionContainer, sectionName) {
    const sectionActionContainer = document.createElement("div");
    sectionActionContainer.id = sectionName+"_action_container";
    sectionActionContainer.classList.add("section_action_container");
    sectionActionContainer.appendChild(createSectionAddAllToCart(sectionName));
    if(!email_present){
      sectionActionContainer.appendChild(createSaveButton(sectionName));
    }
    sectionContainer.appendChild(sectionActionContainer);
}


function createSaveButton(sectionName){
    const saveButton = document.createElement("button");
    saveButton.innerHTML = "EMAIL RESULTS";
    saveButton.classList.add("section_save_button", `${sectionName}_save_button`);
    saveButton.addEventListener('click', () => openEmailPopupWindow(), false);
    return saveButton;
}

function openEmailPopupWindow(){
  showElement(email_popup_window);
}

function handleSpecialSections(sectionContainer, sectionName, psoriasisPresent) {
  const alwaysHiddenSections = [
    "section_treat_restore",
    "section_additional_products_acne"
  ];

  if (alwaysHiddenSections.includes(sectionName)) {
    sectionContainer.classList.add('hide-element');
    return;
  }

  if (sectionName === "section_additional_products") {
    if (psoriasisPresent) {
      // sectionContainer.classList.add('hide-element');
    }
    moveSectionToAdditionalContainer(sectionContainer);
  }
}


function moveSectionToAdditionalContainer(sectionContainer) {
    const sectionAdditional = document.querySelector("#section_additional_content_container_parent");
    sectionAdditional.appendChild(sectionContainer);
}

function appendSectionToMainContainer(sectionContainer, sectionName) {
    if (sectionName !== "section_additional_products") {
        tangent_sections_wrapper_element.appendChild(sectionContainer);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(textSections, sectionContainer, sectionName) {
    if (hasTextSection(textSections, sectionName)) {
        const sectionDiv = createTextContainer(textSections[sectionName], sectionName);
        sectionContainer.appendChild(sectionDiv);
    }
}

function hasTextSection(textSections, sectionName) {
    return textSections[sectionName] !== undefined;
}

function createTextContainer(textContent, sectionName) {
    const container = document.createElement("div");
    container.id = `${sectionName}_text_container`;
    container.classList.add("section_text_container", `${sectionName}_text_container`);
    container.innerHTML = textContent.join(' ');
    return container;
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    showElement(document.getElementById("tangent_selfie_parent_section"));
    if(response.selfie_original_url!=null){
      document.getElementById("tangent_selfie_container").innerHTML = `<img id="selfie_img" src="${response.selfie_original_url}" class="selfie">` ;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
  
   
}

function addConcernFromTags(response){
  const hair_concern_subtext = "hair_concern";
  const skin_concern_subtext = "skin_concern";

  const hair_concern_matchingTexts = getConcernArray(hair_concern_subtext, response.tags);
  const skin_concern_matchingTexts = getConcernArray(skin_concern_subtext, response.tags);

  let hair_htmlOutput="";
  let skin_htmlOutput ="";
  
  if(hair_concern_matchingTexts.length>0){
    hair_htmlOutput = createHtmlList("TOP HAIR CONCERNS", hair_concern_matchingTexts);
  }
  if(skin_concern_matchingTexts.length>0 && skin_concern_matchingTexts[0]!='no'){
    skin_htmlOutput = createHtmlList("TOP SKIN CONCERNS", skin_concern_matchingTexts);
  }
  
  // Output the result
  let concern_container = `<div id="tangent-concern-container" class='tangent-concern-container'>${hair_htmlOutput} ${skin_htmlOutput}</div>`;
  document.getElementById("section_selfie_container_parent").innerHTML += concern_container;
}

function createHtmlList(heading, items){
  // Create the heading
  const headingHtml = `<p class='concern-title'>${heading}</p>`;
  
  // Create the list items
  const listItemsHtml = items.map(item => `<li>${item}</li>`).join("");
  
  // Wrap the list items in a <ul>
  const listHtml = `<ul>${listItemsHtml}</ul>`;
  
  // Combine the heading and the list
  
  const listContainerHtml = `<div>${headingHtml}${listHtml}</div>`
  return listContainerHtml;
}

function getConcernArray(concern_type, tags){
  // Process the array
  return tags
    .filter(str => str.includes(concern_type)) // Filter strings containing the subtext
    .map(
      str => {
        if(str == "hair_concern_dryness_damage"){
          return "Dryness/Damage";
        } else if(str == "hair_concern_gray_texture_changes"){
          return "Gray/Silver or Texture Changes";
        } else if(str == "hair_concern_thinning_shredding"){
          return "Thinning/Shedding";
        } else if(str == "skin_concern_dry_flaky_scalp"){
          return "Dry, flaky scalp";
        } else if(str == "skin_concern_acne"){
          return "Acne (scalp, face or body)";
        } else if(str == "no_skin_concern"){
          return "None, I'm just here for the gorgeous hair";
        } else {
          return str.replace(concern_type, "").replace(/_/g, " ").trim()
        }
      }
    ); // Remove subtext, replace '_' with ' ', and trim extra spaces
}

function switchTab(element) {
  // Hide all tab content
  document.querySelectorAll(".tabcontent").forEach(function(content) {
    content.style.display = "none";
  });
  
  // Remove the "active" class from all tab links
  document.querySelectorAll(".tablinks").forEach(function(link) {
    link.classList.remove("active");
  });

  // Display the clicked tab content and set the tab button to active
  document.getElementById(element.name + "_container").style.display = "block";
  document.getElementById(element.name + "_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener() {
    const buttons = getAddToCartButtons();
    buttons.forEach(addClickListenerToButton);
}

function getAddToCartButtons() {
    return document.querySelectorAll('.tangent-product-add-btn-wrapper');
}

function addClickListenerToButton(button) {
    button.addEventListener('click', () => addToCart(button), false);
}

function loadElementsOnResponseData() {
    const elements = getLoadOnDataElements();
    showElements(elements);
}

function getLoadOnDataElements() {
    return document.querySelectorAll('.load-on-data');
}

function showElements(elements) {
    elements.forEach(element => {
        element.style.display = "block";
    });
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

// Hide the pop-up window when the close button is clicked
function closeEmailPopup(){
  hideElement(email_popup_window);
}

function validateEmail(email){
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

function showDiscountDetailsPopup(){
  showElement(document.getElementById("discount-details-popup"));
}

function closeDiscountDetailPopup(){
  hideElement(document.getElementById("discount-details-popup"));
}

function submitEmail(){
    const email = document.getElementById("user_email_input").value;
    if(!validateEmail(email)) return;

    hideElement(document.getElementById("email-popup-backcover"));
    fetch('https://service.tangent.ai/shopify/responses', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            shop_id:"1651441717", form_id:tangent_form_id, resp_id:tangent_response_id,
            responses:{ form:{ email:email }}
        })
    }).then(() => {
        hideElement(sticky_save_results);
        window.location.reload();
    }).catch((error) => {
        console.error('Error:', error);
    });
}

function hideElement(element){
  element.classList.remove("tangent-visible");
  element.classList.add("tangent-hidden");
}

function showElement(element){
  element.classList.remove("tangent-hidden");
  element.classList.add("tangent-visible");
}

function copyCoupon(){
  navigator.clipboard.writeText("REGIMEN20");
  // Get the snackbar DIV
  var x = document.getElementById("snackbar");

  // Add the "show" class to DIV
  x.className = "show";

  // After 3 seconds, remove the show class from DIV
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
}